import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.9053 7.65523L20.8448 6.59473L12.1553 15.2842L3.46577 6.59473L2.40527 7.65523L12.1553 17.4052L21.9053 7.65523Z" }), 'ChevronDownOutlined');
